<template>
  <HeadlessComboboxOptions
    v-if="suggestions?.length"
    class="absolute z-10 mt-2 flex max-h-[32rem] min-w-[28.5rem] origin-top-left flex-col gap-1 overflow-y-auto rounded border border-bgr-300 bg-bgr py-6 shadow-lg focus:outline-none"
    :static="isOpen && !query"
  >
    <li v-if="!query" class="flex flex-col px-6">
      <h1 class="font-medium text-xl">
        {{ $t(`${trPrefix}popularDestinations`) }}
      </h1>
    </li>

    <HeadlessComboboxOption
      v-for="(option, index) in suggestions"
      :key="`${index}-${option.code}`"
      v-slot="{ selected, active }"
      :value="option"
      as="template"
    >
      <li
        class="flex min-h-14 cursor-pointer flex-row items-center gap-2 px-6"
        :class="{
          'bg-bgr-100': active || selected,
        }"
      >
        <WebccIcon
          :name="`content/${isSuggestionTypeAccom(option.type) ? 'house' : 'pin'}`"
          class="h-5 w-5 shrink-0"
          filled
        />

        <div class="flex flex-col gap-0">
          <span class="font-medium" :title="option.code">
            {{ option.label }}
          </span>
          <span class="font-medium text-txt-weak">
            {{ option.subtitle }}
          </span>
        </div>
      </li>
    </HeadlessComboboxOption>
  </HeadlessComboboxOptions>
</template>

<script setup lang="ts">
import type { SuggestionOption } from '~/composables/useDestinationSearch'
import { isSuggestionTypeAccom } from '~/utils/suggestions'

const trPrefix = 'www.components.site.Header.'

defineProps<{
  suggestions: SuggestionOption[]
  isOpen: boolean
  query: string
}>()
</script>
